import { injectTranslate } from '@recruitee/i18n';
import { usersAvatarsCellFactory } from '@recruitee/user-interface';

import { OfferColumnId } from '../../../offers-page/offers-table/offers.table-service';
import { defineOfferTableColumn } from './utils';

export const followersColumn = defineOfferTableColumn(() => ({
  id: OfferColumnId.Followers,
  label: injectTranslate()('app.offers.table.followers'),
  visible: false,
  geometry: {
    width: 120,
    minWidth: 120,
    autoFitProp: 'width',
  },
  options: {
    draggable: false,
    resizable: true,
    removable: true,
    sortable: false,
  },
  componentFactory: usersAvatarsCellFactory('followers'),
}));
